import ModelApi from "./ModelApi"
import ApiClient from "./ApiClient"

/* __DEMO_MODE__ is a compile-time constant (vue.config.js DefinePlugin).
   Conditional require keeps demo ModelApi + fixtures out of production bundles. */
let ProjectApi
let UserApi
let RedcapApiTokenApi
let OtlfbSurveyApi
let SubstanceApi
let SubstanceModeApi

if (__DEMO_MODE__) {
  const DemoModelApi = require("./demoModelApi").default
  ProjectApi = new DemoModelApi("project")
  UserApi = new DemoModelApi("user")
  RedcapApiTokenApi = new DemoModelApi("redcapApiToken")
  OtlfbSurveyApi = new DemoModelApi("otlfbSurvey")
  SubstanceApi = new DemoModelApi("substance")
  SubstanceModeApi = new DemoModelApi("substanceMode")
} else {
  ProjectApi = new ModelApi("/project")
  UserApi = new ModelApi("/user")
  RedcapApiTokenApi = new ModelApi("/redcapApiToken")
  OtlfbSurveyApi = new ModelApi("/otlfbSurvey")
  SubstanceApi = new ModelApi("/substance")
  SubstanceModeApi = new ModelApi("/substanceMode")
}

export {
  ProjectApi,
  UserApi,
  RedcapApiTokenApi,
  OtlfbSurveyApi,
  SubstanceApi,
  SubstanceModeApi
}

export default ApiClient
